import * as React from 'react';
import './itemCard.scss';
import {
  GoogleDoc,
  ThreeDots,
  DocSearch,
  EvolvingInsights
} from '../../Icon/icon';
import { Dropdown } from '../../Dropdown/dropdown';
import { ItemUpdateModal } from '../../ItemUpdateModal/itemUpdateModal';
import {
  isKeepActiveEnabled,
  isArchiveEnabled,
  isUpdateDisabled,
  getConfPresentationLink,
  getSchemaForm
} from '../../../utils';
import { ItemKeepActiveModal } from '../../ItemKeepActiveModal/itemKeepActiveModal';
import { ItemCardProps } from './itemCard';
import { useSelector } from '../../../utils/useSelector';
import { ItemArchiveModal } from '../../ItemArchiveModal/itemArchiveModal';
import TooltipPopover from '../../Popover/popover';
import { Presentation } from 'rcd-cpp-ui/ui/icon';
import { Role } from '../../../enums/Role';
import { Schema } from '../../../types/Metadata';
import { NodeType } from '../../../enums/NodeType';

export const ItemCardActions = ({
  item,
  view,
  group
}: Pick<ItemCardProps, 'item' | 'view' | 'group'>) => {
  const getAPI = useSelector(s => s?.app?.elFn?.getAPI);
  const showExpiryActions = useSelector(
    s => s.app?.user?.roles?.includes(Role.admin) || !s.view?.viewingAs
  );
  const schema = useSelector(
    s =>
      s.planning?.selectedWorkspace?.schemas?.filter(
        s => s?.props?.type == NodeType.Item
      )[0]
  );
  const { getDataDetail } = getAPI();
  const [selectedAction, setSelectedAction] = React.useState<any>(null);
  const [selectedData, setSelectedData] = React.useState<any>(null);
  const [selectedSchemaForm, setSelectedSchemaForm] =
    React.useState<Schema>(null);
  if (!view?.props || !item?.props) return null;

  if (group?.props?.isMyTaskGroup || view?.props?.isEFSBuilder) {
    const googleDocUrl = item.props.googleDocumentUrl;
    const presentationLink = getConfPresentationLink(item);
    if (googleDocUrl || presentationLink) {
      return (
        <div className="item-card-actions">
          <a target="_blank" href={googleDocUrl || presentationLink}>
            {googleDocUrl ? <GoogleDoc /> : <Presentation />}
          </a>
        </div>
      );
    }
  }
  if (view.props.isMyExpiryDashboard) {
    if (!showExpiryActions) return null;
    return (
      <div className="item-card-actions">
        <Dropdown
          options={[
            { key: 'keepActive', displayName: 'Keep Active' },
            { key: 'update', displayName: 'Update' },
            { key: 'archive', displayName: 'Archive' }
          ]}
          disabled={o => {
            switch (o.key) {
              case 'archive':
                return !isArchiveEnabled(item);
              case 'keepActive':
                return !isKeepActiveEnabled(item);
              case 'update':
                return isUpdateDisabled(item);
            }
          }}
          position="right"
          renderOption={o => (
            <div>
              <span className="dd-text" data-txt={o.displayName}>
                {o.displayName}
              </span>
            </div>
          )}
          onSelect={async o => {
            if (['update', 'keepActive', 'archive'].includes(o.key)) {
              const r = await getDataDetail(item.props.refId);
              const d = r?.data[0];
              const schemaForm = getSchemaForm(schema, d);
              setSelectedData(d);
              setSelectedSchemaForm(schemaForm);
              setSelectedAction(o.key);
            }
          }}
        >
          <div className="three-dots">
            <ThreeDots />
          </div>
        </Dropdown>

        {item?.props?.evolvingInsights && (
          <TooltipPopover
            packed={true}
            type="info"
            pointerPosition="top"
            content={
              <div className="popover-description-container">
                <div>Evolving Insights</div>
              </div>
            }
          >
            <div>
              <EvolvingInsights />
            </div>
          </TooltipPopover>
        )}
        {selectedAction == 'update' && (
          <ItemUpdateModal
            data={selectedData}
            schema={schema}
            schemaForm={selectedSchemaForm}
            onCancel={() => {
              setSelectedAction(null);
              setSelectedData(null);
              setSelectedSchemaForm(null);
            }}
          />
        )}
        {selectedAction == 'keepActive' && (
          <ItemKeepActiveModal
            data={selectedData}
            onCancel={() => {
              setSelectedAction(null);
              setSelectedData(null);
              setSelectedSchemaForm(null);
            }}
          />
        )}
        {selectedAction == 'archive' && (
          <ItemArchiveModal
            data={selectedData}
            onCancel={() => {
              setSelectedAction(null);
              setSelectedData(null);
              setSelectedSchemaForm(null);
            }}
          />
        )}
      </div>
    );
  }
  return null;
};
